module.exports = __webpack_public_path__ + "static/img/h-head-kiko.68eae6a1.webp";